/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentsListStatusNavigation: "shipments-list-status-navigation",
  shipmentsListAll: "shipments-list-all",
  shipmentsListPending: "shipments-list-pending",
  shipmentsListUnassigned: "shipments-list-unassigned",
  shipmentsListAssigned: "shipments-list-assigned",
  shipmentsListInProgress: "shipments-list-in-progress",
  shipmentsListForecasted: "shipments-list-forecasted",
  shipmentsListCompleted: "shipments-list-completed",
  shipmentsListCancelled: "shipments-list-cancelled",
  shipmentsListAutoPlan: "shipments-list-auto-plan",
  shipmentsListCreateOrder: "shipments-list-create-order",
  shipmentsListCancel: "shipments-list-cancel",
  shipmentsListExecuteBulkAccept: "shipments-list-execute-bulk-accept",
} as const;
